import { format, isValid, parseISO } from "date-fns";
import { de } from 'date-fns/locale';
import i18next from 'i18next';

export class Util {
    static formatDate = (date: Date | string | null | undefined): string => {
        if (!date) return '-';
        
        try {
            const dateObj = typeof date === 'string' ? parseISO(date) : date;
            
            if (!isValid(dateObj)) return '-';
            
            return format(dateObj, 'P', { locale: de });
        } catch (error) {
            console.warn('Invalid date format:', date);
            return '-';
        }
    };
    static translate = (key: string, options = {}) => {
        return i18next.t(key, options);
    };
}